import React from "react";
import { Redirect, Route, RouteProps, useHistory } from "react-router-dom";
import { PermissionProps } from "../Model/Permission";
import { getUserCredential } from "../redux/reducers/LocalUserReducer";
import { useTypedSelector } from "../redux/reducers/RootReducer";
import PermissionUtil from "../Utility/PermissionUtil";
import { usePermission } from "./Common/PermissionProvider";
import Forbidden from "./Forbidden";
import useLicenseValidation from "./Hooks/useLicenseValidation";

interface PrivateRouteProps extends RouteProps, PermissionProps {
  additionalRule?: boolean;
}

const PrivateRoute = ({ component, permissions, componentId, additionalRule, ...rest }: PrivateRouteProps) => {
  const { isLicenseValid } = useLicenseValidation();
  const user = useTypedSelector((state) => getUserCredential(state));
  let canReadComponent = permissions && componentId ? PermissionUtil.canReadComponent(permissions, componentId) : true;

  canReadComponent = additionalRule !== undefined ? additionalRule && canReadComponent : canReadComponent;

  if (isLicenseValid === undefined) return <></>;
  if (isLicenseValid === false) window.location.reload();
  return user && canReadComponent ? (
    <Route {...rest} component={component} />
  ) : user ? (
    <Route {...rest} component={Forbidden} />
  ) : (
    <Redirect to={{ pathname: "/login" }} />
  );
};

export const PrivateRouteWithPermission = usePermission(PrivateRoute);
export default PrivateRoute;
